export default __webpack_public_path__ + "static/media/thumbnail.ff7f60e8.png";